import React from 'react';
import moment from 'moment';
import { Text } from '@getpingback/realeza';
import { PencilSingleIcon, TrashCanIcon } from '@stash-ui/regular-icons';
import { Button } from '@material-ui/core';
const Lesson = ({ lesson, onEditLesson, onDelete }) => {
  return (
    <div className="education__course__lessons__lesson">
      <div className="education__course__lessons__lesson__left">
        <div className="education__course__lessons__lesson__left__item">
          <Text size={16} weight="bold" color="white">
            Name:
          </Text>
          <Text size={16} weight="regular" color="white">
            {lesson.name}
          </Text>
        </div>
        <div className="education__course__lessons__lesson__left__item">
          <Text size={16} weight="bold" color="white">
            Duration:
          </Text>
          <Text size={16} weight="regular" color="white">
            {lesson.duration}
          </Text>
        </div>
        <div className="education__course__lessons__lesson__left__item">
          <Text size={16} weight="bold" color="white">
            Video URL:
          </Text>
          <a href={lesson.videoUrl} target="_blank">
            {lesson.videoUrl}
          </a>
        </div>

        <div className="education__course__lessons__lesson__left__item">
          <Text size={16} weight="bold" color="white">
            Created at:
          </Text>
          <Text size={16} weight="regular" color="white">
            {moment(lesson.createdAt).format('DD/MM/YYYY HH:mm')}
          </Text>
        </div>
      </div>
      <div className="education__course__lessons__lesson__right">
        <Button variant="contained" color="primary" startIcon={<PencilSingleIcon />} onClick={onEditLesson}>
          Edit
        </Button>
        <Button variant="contained" color="secondary" startIcon={<TrashCanIcon />} onClick={onDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default Lesson;
